// extracted by mini-css-extract-plugin
export default {"root":"filesReader_root__JpYiO","input":"filesReader_input__yStAh"};